import { render, staticRenderFns } from "./double.vue?vue&type=template&id=99de2632"
import script from "./double.vue?vue&type=script&lang=js"
export * from "./double.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports